export default __webpack_public_path__ + "static/media/img3.af465c83.png";